const data = {
  name: '臼居 和真 Usui Kazuma',
  informations: [
    {
      id: 1,
      label: '所在地',
      content: '京都市内'
    },
    {
      id: 2,
      label: 'GitHub',
      content: '<a class="link" href="https://github.com/282Haniwa" target="_blank">282haniwa</a>'
    },
    {
      id: 3,
      label: '所持資格',
      content: '基本情報技術者, 応用情報技術者'
    },
    {
      id: 4,
      label: '興味関心',
      content: 'webアプリ開発, フロントエンド開発, ゲーム開発'
    },
    {
      id: 5,
      label: 'Mail',
      content: '<a class="link" href="mailto:usuieng@gmail.com">usuieng@gmail.com</a>'
    }
  ],
  text: `ユーザにとって使いやすいUIを実装していくことを第一に考え、実装していきます。<br />
  また、可読性・再利用性が高いプログラムを書くように意識し、変更にも耐えられる実装を心がけています。`,
  biography: `京都産業大学 コンピュータ理工学部 20年卒業予定<br />
  株式会社ラグーンコーポレーション(アルバイト)/webアプリケーション フロントエンド開発(2年)`
}

export default data
